import { render, staticRenderFns } from "./ModalSuccessTransaction.vue?vue&type=template&id=b286d506&scoped=true&"
import script from "./ModalSuccessTransaction.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuccessTransaction.vue?vue&type=style&index=0&id=b286d506&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b286d506",
  null
  
)

export default component.exports